import React from "react";

import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import { Toaster } from "@shared/components/ui/Toaster";
import { ErrorView } from "@shared/components/error-view";
import { DebugDrawer } from "@shared/features/debug-drawer/debug-drawer";
import { DemoDrawer } from "@shared/features/demo-drawer/demo-drawer";
import { ResponsiveContextProvider } from "@shared/hooks/responsive/responsiveContext";
import { FormFactory } from "@shared/features/formv2/FormFactory";
import { TooltipProvider } from "@shared/components/ui/Tooltip";
import { SupportDrawer } from "@shared/features/support/components/support-drawer";
import { initTracking, Sentry } from "@shared/utils/init-tracking";

import { App } from "@/App.jsx";

import "./index.css";

const queryClient = new QueryClient();

initTracking();

ReactDOM.createRoot(document.getElementById("root")).render(
  <Sentry.ErrorBoundary
    fallback={ErrorView}
    onReset={() => {
      window.location.reload();
    }}
  >
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <ResponsiveContextProvider>
          <FormFactory>
            <TooltipProvider>
              <App />
              <Toaster />
              <DebugDrawer />
              <DemoDrawer />
              <SupportDrawer />
            </TooltipProvider>
          </FormFactory>
        </ResponsiveContextProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </Sentry.ErrorBoundary>
);
